import React from 'react'
import * as forms from './index'
import { TFunction } from 'i18next'
import { ProjectFormStepsType, ProjectKindType } from 'src/core/models'

interface ProjectFormSectionsType {
  key: ProjectFormStepsType,
  headerTitle: string,
  headerSubtitle: string,
  component: React.FunctionComponent,
  show: boolean | ProjectKindType
}

export const projectFormSections = (
  t: TFunction, selectedKind: ProjectKindType, isTaxRelief: boolean
): ProjectFormSectionsType[] => [
  {
    key: 'DEFINITION',
    headerTitle: t('Projects.FormSections.Definition'),
    headerSubtitle: t('Projects.FormSections.DefinitionTitle'),
    component: forms.ProjectFormDefinition,
    show: true
  },
  {
    key: 'LOCATION',
    headerTitle: t('Projects.FormSections.Location'),
    headerSubtitle: t('Projects.FormSections.LocationTitle'),
    component: forms.ProjectFormLocation,
    show: selectedKind
  },
  {
    key: 'CONTENT',
    headerTitle: t('Projects.FormSections.Content'),
    headerSubtitle: t('Projects.FormSections.ContentTitle'),
    component: forms.ProjectFormContent,
    show: selectedKind
  },
  {
    key: 'TAX_RELIEF',
    headerTitle: t('Projects.FormSections.TaxRelief'),
    headerSubtitle: t('Projects.FormSections.TaxReliefTitle'),
    component: forms.ProjectFormTaxRelief,
    show: selectedKind && selectedKind === 'contribution' && isTaxRelief
  },
  {
    key: 'STOCK',
    headerTitle: t('Projects.FormSections.Price'),
    headerSubtitle: t('Projects.FormSections.PriceTitle'),
    component: forms.ProjectFormStock,
    show: selectedKind
  },
  {
    key: 'CERTIFICATION',
    headerTitle: t('Projects.FormSections.Certification'),
    headerSubtitle: t('Projects.FormSections.CertificationTitle'),
    component: forms.ProjectFormCertification,
    show: selectedKind && selectedKind !== 'contribution'
  },
  {
    key: 'DOCUMENTATION',
    headerTitle: t('Projects.FormSections.Documentation'),
    headerSubtitle: t('Projects.FormSections.DocumentationTitle'),
    component: forms.ProjectFormDocumentation,
    show: selectedKind && selectedKind !== 'contribution'
  },
  {
    key: 'CONFIGURATION',
    headerTitle: t('Projects.FormSections.Configuration'),
    headerSubtitle: t('Projects.FormSections.ConfigurationTitle'),
    component: forms.ProjectFormConfiguration,
    show: selectedKind
  }
]
